import { Box } from "@mantine/core";

import { LiveMinting } from "~features/MintPage/live-minting/LiveMinting";
import { useMintPage } from "~hooks/useMintPage";
import { MintContext } from "~hooks/useMintState";

export const LiveMintingEmbed = ({
  collectionId,
  width = 340,
}: {
  collectionId: string;
  width?: number;
}) => {
  const mintPageHook = useMintPage(collectionId);
  return (
    <MintContext.Provider value={mintPageHook}>
      <Box w={width}>
        <LiveMinting />
      </Box>
    </MintContext.Provider>
  );
};
